module.exports = __webpack_public_path__ + "img/other3.afe6f8a9.png";